module.exports = __webpack_public_path__ + "img/7.51218207.png";